import { render, staticRenderFns } from "./Dendrogram.vue?vue&type=template&id=d45b35fc&scoped=true&"
import script from "./Dendrogram.vue?vue&type=script&lang=js&"
export * from "./Dendrogram.vue?vue&type=script&lang=js&"
import style0 from "./Dendrogram.vue?vue&type=style&index=0&id=d45b35fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45b35fc",
  null
  
)

export default component.exports